<script type="text/babel">
import { $get } from '@makeabledk/vue-ui/support/helpers'
import { fromEvent, merge, of } from 'rxjs'
import { map } from 'rxjs/operators'
import HasSubscriptions from '@makeabledk/vue-ui/mixins/has-subscriptions'
import TabState from './TabState.js'

export default {
    mixins: [HasSubscriptions],

    provide() {
        return {
            TabState: this.TabState,
        }
    },

    props: ['teleport', 'activeTabClass'],

    emits: ['rewrite'],

    data() {
        return {
            TabState: new TabState(this.teleport, this.activeTabClass),
        }
    },

    mounted() {
        const check = () => {
            document.querySelector(this.teleport) ? this.mount() : setTimeout(check, 100)
        }

        check()
    },

    methods: {
        mount() {
            this.subscribe(this.windowHash(), (hash) => {
                this.TabState.active.next({
                    id: hash.replace('#', ''),
                    url: hash,
                })
            })

            this.subscribe(this.TabState.active, (active) => {
                this.selectDefaultWhenNotFound(active)

                this.$emit('rewrite', active.url)
            })
        },

        selectDefaultWhenNotFound(active) {
            if ($get(this.TabState.tabs, active.id) !== true && active.id !== '') {
                this.TabState.active.next({
                    id: '',
                    url: '',
                })
            }
        },

        windowHash() {
            return merge(of(window.location.hash), fromEvent(window, 'hashchange').pipe(map(() => window.location.hash)))
        },
    },

    render() {
        return this.$slots.default()
    },
}
</script>
